var KR_I18n = KR_I18n || {};

KR_I18n["pt-BR"] = {"register":"REGISTRAR","label_do_register":"Registrar meu cartão","ask_register_pay":"Registrar meu cartão","smartform_register_payment_method":"Registrar um método de pagamento","smartform_register_card":"Registrar o meu cartão","smartform_register_another_payment_method":"Registrar outro método de pagamento","smartform_wallet_remove_payment_method":"Remover um método de pagamento registrado","smartform_wallet_register_another_card":"Registrar outro cartão"};

if ((typeof(module) !== "undefined") && (typeof(module.exports) !== "undefined")) module.exports = KR_I18n["pt-BR"];

